import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GenericIndexScene } from 'shared-ui/lib/components/table/TableX';
import { setupQueryConfig } from 'shared-ui/lib/config/query.config';
import { groupColumns } from '../../columns/group.columns';
import { routesConfig } from '../../config/routes.config';
import { useGroupIndexSceneLazyQuery } from '../../generated/graphql';

const MAX_GROUPS_PER_BUSINESS = 20;
const createButtonClassName =
  'float-right py-2 px-4 border transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary disabled:bg-gray-300';

export const GroupIndexScene = (): JSX.Element => {
  const query = useGroupIndexSceneLazyQuery(setupQueryConfig());
  const { t } = useTranslation('GroupIndexScene');
  const navigate = useNavigate();
  const totalCount = query[1].data?.groups.totalCount ?? 0;
  const atMax = totalCount >= MAX_GROUPS_PER_BUSINESS;

  const handleCreateClick = () => {
    if (atMax) {
      toast.error(t('maxGroups'));
      return;
    }
    navigate(routesConfig.SETTINGS.GROUPS.CREATE);
  };

  return (
    <GenericIndexScene
      tNs="GroupIndexScene"
      dataPath="groups.list"
      countPath="groups.totalCount"
      columns={[
        groupColumns.name,
        groupColumns.notificationEmail,
        groupColumns.vehicleCount,
        groupColumns.userCount,
        groupColumns.linkToGroup,
      ]}
      query={query}
      Tool={
        <button
          type="button"
          className={`${createButtonClassName}${atMax ? ' bg-gray-300 hover:bg-gray-300 cursor-not-allowed' : ''}`}
          onClick={handleCreateClick}
        >
          {t('add')}
        </button>
      }
    />
  );
};
